'use strict';
import forEach from 'lodash/forEach';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import moment from 'moment';

PersistentUploaderFactory.$inject = [
  '$log',
  '$toast',
  'DeviceServices',
  'PersistentUploaderService',
];

export function PersistentUploaderFactory(
  $log,
  $toast,
  DeviceServices,
  PersistentUploaderService,
) {
  config.generateExifData = generateExifData;

  return config;

  /**
   *
   * @param {Object} options
   * @param {Object} options.onSuccessLocals
   * @param {Expression} options.onSuccess - parsed with the angular $parse service and called with the $injector as the context
   * @param {Function} options.afterUploadStarted - called with (PU fileData, file, key)
   * @param {Function} options.getModelId
   * @param {Function} options.getLocals
   * @param {Function} options.getFilename
   * @param {Function} options.generateFileRequest
   * @param {FILE_USAGE} options.usage
   * @returns {{onSuccess: onFileSelectSuccess, onError: onFileSelectError, retryUploads: retryUploads}}
   */
  function config(options) {

    return {
      onSuccess: onFileSelectSuccess,
      onError: onFileSelectError,
      retryUploads: retryUploads,
      bindUploadsToScope: bindUploadsToScope
    };

    /**
     *
     * @param $scope
     * @param {Object} bindOptions
     * @param {String} [bindOptions.controllerAs]
     * @param {String} bindOptions.pendingUploadsName - was pendingUploadsModel
     */
    function bindUploadsToScope($scope, bindOptions) {
      let loadedFilesOnce = false;
      let unwatchFilesList = $scope.$watch(options.getModelId,
        function (newId) {
          if (newId && !loadedFilesOnce) {
            loadedFilesOnce = true;
            unwatchFilesList();

            PersistentUploaderService.bindToScope($scope, bindOptions.pendingUploadsName, newId, bindOptions.controllerAs);
          }
        });
    }

    function onFileSelectSuccess(fileData, fromCamera) {
      //console.log('PersistentUploaderFactory.onFileSelectSuccess: fromCamera = ' + fromCamera);
      const locals = isObject(options.onSuccessLocals) ?
        options.onSuccessLocals :
        isFunction(options.getLocals) ? options.getLocals() : null;

      if (fileData.file) {
        var data = options.generateFileRequest();
        data.modelId = options.getModelId();
        data.fileUri = fileData.uri;
        data.filename = options.getFilename();
        data.usage = options.usage;
        data.onSuccess = options.onSuccess;
        data.onSuccessLocals = locals;
        if (fromCamera) {
          generateExifData().then(exif => {
            const key = PersistentUploaderService.addFile(fileData.file, Object.assign(data, exif));
            return uploadSingleFile(key);
          })
        } else {
          const key = PersistentUploaderService.addFile(fileData.file, data);
          return uploadSingleFile(key);
        }
      } else if (fileData.files && fileData.files.length) {

        // test case:

        var promises = [];
        forEach(fileData.files, function withFile(file) {
          var data = options.generateFileRequest();
          data.modelId = options.getModelId();
          data.fileUri = fileData.uri;
          data.filename = isFunction(options.getFilename) ? options.getFilename() : null;
          data.usage = options.usage;
          data.onSuccess = options.onSuccess;
          data.onSuccessLocals = locals;

          const key = PersistentUploaderService.addFile(file, data);
          promises.push(uploadSingleFile(key));
        });

        return Promise.all(promises);
      } else {
        return Promise.reject('Must provide a file or FileList to upload')
      }
    }

    function uploadSingleFile(key) {
      const uploadPromise = PersistentUploaderService.upload(key);
      const pFileData = PersistentUploaderService.getFileData(key);
      const pFile = PersistentUploaderService.getFile(key);

      if (isFunction(options.afterUploadStarted)) {
        options.afterUploadStarted(pFileData, pFile, key);
      }

      return uploadPromise;
    }

    function onFileSelectError(error) {
      $log.warn('failed to save file', error);
    }

    function retryUploads() {
      PersistentUploaderService.tryUploads();
    }
  }

  // TODO: Need to calculate the Ref values and supply them here I suppose
  function generateExifData() {
    const metadata = {
      DateTimeOriginal: moment().format('YYYY:MM:DD HH:mm:ss'),
    };

    // this must succeed even if retrieving the gps data fails or times out
    return DeviceServices.getCurrentPosition()
      .then(payload => {
        if (!payload.position || !payload.position.coords) {
          return {
            metadata,
          };
        } else {
          const position = payload.position;
          return {
            metadata: {
              ...metadata,
              TimeZoneOffset: -(new Date().getTimezoneOffset()), // negate to get the standard offset in minutes

              GPSLatitude: position.coords.latitude, // Decimal needs to be converted before saving to exif data
              GPSLongitude: position.coords.longitude, // Decimal needs to be converted before saving to exif data
              GPSAccuracy: position.coords.accuracy,
              GPSAltitude: position.coords.altitude,
              GPSAltitudeAccuracy: position.coords.altitudeAccuracy,
              GPSImgDirection: position.coords.heading,
              GPSImgDirectionRef: 'T',
              GPSTimestamp: position.timestamp
            }
          };
        }
      }, function onError(error) {
        $toast.showMessage('Failed to retrieve GPS data!', null, 'error');
        console.warn('Failed to retrieve GPS data');
        console.error(error);

        return {
          metadata,
        };
      });
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/upload-service/PersistentUploaderFactory.js